import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Pagination} from '../../shared/Models/Pagination';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserTerm} from '../Models/UserTerm';
import { catchError } from 'rxjs/operators';

@Injectable()
export class GeneralTermService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getTermsList(gridData) {
    return this.http.get<Pagination<any>>(environment.apiUrl + '/backoffice/terms/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getTerm(termId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/terms/' + termId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageTerm(generalTerm, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/terms/' + id, {general_term: generalTerm})
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/terms/', {general_term: generalTerm})
      .pipe(catchError(res => this.helper.catchError(res)));
  }


  removeFile(fileId, generalTermId) {
    return this.http.delete(environment.apiUrl + '/backoffice/terms/' + generalTermId + '/remove-file/' + fileId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getTermByKey(key: string): Observable<any> {
    return this.http.get(environment.apiUrl + '/users/term/' + key)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public acceptTerm(data: UserTerm, token: string): Observable<any> {
    return this.http.post(environment.apiUrl + '/users/term/' + token, (data))
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
